<template>
  <div class="p-2">
    <!-- Mobile view with simplified form -->
    <div v-if="isMobile" class="mobile-container">
      <div class="mobile-header">
        <div class="back-button" @click="$emit('close')">
          <i class="fas fa-arrow-left"></i>
        </div>
        <h4 class="mobile-title">
          {{
            obj && obj.cod_cliente
              ? "Cliente #" + obj.cod_cliente
              : "Novo Cliente"
          }}
        </h4>
        <div class="mobile-avatar" v-if="obj">
          <file-upload
            :enable-title="false"
            :max-files="1"
            :value="obj.foto"
            :freeStyle="true"
            :photoIcon="true"
            @input="updateFoto"
            :enableEdit="obj.cod_cliente ? true : false"
          ></file-upload>
        </div>
      </div>

      <div class="mobile-form">

        <div class="mobile-input-group">
          <label>Telefone</label>
          <input
            v-model="obj.Telefone"
            class="form-control"
            placeholder="(00) 00000-0000"
            type="tel"
            pattern="\d*"
            @blur="validaTelefone"
            v-mask="['(##) #####-####', '(##) #####-####']"
          />
        </div>


        <div class="mobile-input-group">
          <label>Nome</label>
          <b-input
            v-model="obj.Nome"
            class="form-control"
            placeholder="Nome completo"
            type="text"
          />
        </div>

        <div class="mobile-input-group">
          <label>CPF/CNPJ</label>
          <b-input
            v-model="obj.CGC"
            class="form-control"
            placeholder="000.000.000-00"
            type="text"
            @blur="validaCPF"
            pattern="\d*"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
          />
          <div v-if="cpfValido === false" class="invalid-feedback d-block">
            CPF/CNPJ inválido
          </div>
        </div>

        <div class="mobile-actions">
          <b-btn @click="saveSimplified" variant="success" block>
            Salvar
          </b-btn>
          <b-btn
            @click="$emit('close')"
            variant="outline-secondary"
            block
            class="mt-2"
          >
            Cancelar
          </b-btn>
        </div>

        <div class="mobile-tabs" v-if="obj && obj.cod_cliente">
          <div
            v-for="(mn, idx) in menuLista"
            :key="idx"
            :class="{ active: mn.label == menuSelected }"
            @click="menuSelected = mn.label"
          >
            <i :class="mn.icon"></i>
            <span>{{ mn.label }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop view (original) -->
    <div v-else class="row">
      <div class="col-12 col-md-3">
        <div
          class="text-center pt-0 border border-grey rounded-pill mb-4"
          style="width: 200px; height: 200px; margin: 0 auto; overflow: hidden"
          v-if="obj"
        >
          <file-upload
            :enable-title="false"
            :max-files="1"
            :value="obj.foto"
            :freeStyle="true"
            :photoIcon="true"
            @input="updateFoto"
            :enableEdit="obj.cod_cliente ? true : false"
          ></file-upload>
        </div>
        <b-btn v-if="fotoAlterado" @click="saveFoto" variant="success" block>
          Salvar Foto
        </b-btn>

        <div class="text-center bg-light textCadastro py-2">
          <div class="row my-4">
            <div class="col-4">
              Código <br />
              {{ obj && obj.cod_cliente }}
            </div>
            <div class="col-4">
              Cadastro <br />
              {{ obj && obj.dt_cadastro | moment("DD/MM/YYYY") }}
            </div>
            <div class="col-4">
              Saldo <br />
              {{ obj && obj.saldo | currency }}
            </div>
          </div>
        </div>
        <div class="menu-lateral">
          <div
            v-for="(mn, idx) in menuLista"
            :key="idx"
            :class="{ selected: mn.label == menuSelected }"
            @click="menuSelected = mn.label"
          >
            <i :class="mn.icon"></i> {{ mn.label }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-9">
        <div v-if="obj && menuSelected == 'Resumo'">
          <cliente-form-completo-dash :obj="obj"></cliente-form-completo-dash>
        </div>
        <div v-if="obj && menuSelected == 'Cadastro'">
          <cliente-form-completo-form
            :id="obj.cod_cliente"
            @openCadastro="
              (id) => {
                this.id = id;
                this.carregar();
                if (this.onModal) {
                  this.$emit('closeAndOpen', id);
                }
              }
            "
            @close="close"
          ></cliente-form-completo-form>
        </div>
        <div v-if="obj && obj.cod_cliente && menuSelected == 'Comandas'">
          <cliente-comandas :cod_cliente="obj.cod_cliente"></cliente-comandas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";
import validador from "../../utils/validador";
import cep from "@/utils/cep";
import ClientesLib from "@/libs/ClientesLib";
import moment from "moment";
import ClienteFormCompletoDash from "./ClienteFormCompletoDash.vue";
import ClienteFormCompletoForm from "./ClienteFormCompletoForm.vue";
import ClienteComandas from "./ClienteComandas.vue";
import axios from "@/utils/axios";

export default {
  components: {
    FileUpload,
    ClienteFormCompletoDash,
    ClienteFormCompletoForm,
    ClienteComandas,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    onModal: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.carregar();
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  data() {
    return {
      obj: null,
      menuSelected: "Resumo",
      menus: [
        {
          label: "Resumo",
          icon: "fa fa-chart-pie mr-2",
          onInset: false,
        },
        {
          label: "Cadastro",
          icon: "far fa-clipboard mr-2",
          onInset: true,
        },
        {
          label: "Comandas",
          icon: "fa fa-barcode mr-2",
          onInset: false,
        },
      ],
      cpfValido: null,
      lista_ufs: [],
      lista_cidades: [],
      options_cidades: [],
      loadingCEP: false,
      listBairros: this.$store.state.enderecos.bairros.map((b) => {
        return b.bairro;
      }),
      listLogradouros: this.$store.state.enderecos.logradouros.map((b) => {
        return b.logradouro;
      }),
      autoCompleteStyle: {
        vueSimpleSuggest: "position-relative",
        inputWrapper: "",
        defaultInput: "form-control inputMenor",
        suggestItem: "list-group-item",
        suggestions: "list-group",
        maxSuggestions: 2,
      },
      loaded: false,
      fotoAlterado: null,
      isMobile: false,
    };
  },
  watch: {
    "obj.foto": {
      handler: function () {},
      deep: true,
    },
  },
  computed: {
    menuLista() {
      return this.menus;
    },
  },
  methods: {
    async validaTelefone() {
      if (this.obj.Telefone && this.obj.Telefone.length < 8) {
        this.$swal({
          title: "Telefone inválido!",
          text: "Por favor, verifique o telefone informado",
          icon: "error",
        });
        return;
      }
      const busca = await axios.post("clientes/buscarPorTel", {
        telefone: this.obj.Telefone.trim()
          .replace(" ", "")
          .replace("-", "")
          .match(/\d+/g)
          .join(""),
      });
      console.log("busca", busca);
      if (busca && busca.data && busca.data.success) {
        //variavel que guarda o telefone encontrado e pergunta se deseja utilizar o cadastro
        const telefoneEncontrado = busca.data.data.Telefone;
        this.$swal({
          title: "Telefone já cadastrado!",
          text: "Deseja utilizar o cadastro de " + telefoneEncontrado + "?",
          icon: "error",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.obj.cod_cliente = busca.data.data.cod_cliente;
            this.obj.Nome = busca.data.data.Nome;
            this.obj.CGC = busca.data.data.CGC;
            console.log("busca.data.data.cod_cliente", busca.data.data.cod_cliente);
            //fecha o modal
            this.$emit("closeAndOpen", busca.data.data.cod_cliente);
          }
        });
      }
    },

    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    async saveSimplified() {
      if (!this.obj.Nome || !this.obj.Telefone || !this.obj.CGC) {
        this.$swal({
          title: "Campos obrigatórios!",
          text: "Nome, Telefone e CPF/CNPJ são obrigatórios",
          icon: "error",
        });
        return;
      }

      if (this.cpfValido === false) {
        this.$swal({
          title: "CPF/CNPJ inválido!",
          text: "Por favor, verifique o CPF/CNPJ informado",
          icon: "error",
        });
        return;
      }

      try {
        const result = await ClientesLib.salvarCliente({...this.obj, cod_empresa: 1, foto: null});
        if (result && result.success) {
          this.$swal({
            title: "Cliente salvo com sucesso!",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });

          if (!this.obj.cod_cliente && result.data) {
            this.id = result.data;
            await this.carregar();
            this.$emit("closeAndOpen", result.data);
          }
        }
      } catch (err) {
        this.$swal({
          title: "Erro ao salvar!",
          text: "Tente novamente mais tarde",
          icon: "error",
        });
      }
    },
    async saveFoto() {
      if (this.fotoAlterado) {
        await ClientesLib.salvarCliente(this.obj);
        this.$swal({
          title: "Foto salva com sucesso!",
          icon: "success",
          showConfirmButton: false,
          toast: true,
          timer: 1000,
          position: "top-end",
        });
        this.fotoAlterado = false;
      }
    },
    async updateFoto(imgList) {
      if (!this.loaded || !this.obj.foto) return;
      console.log("imgList", imgList);

      if (this.obj.cod_cliente) {
        if (imgList.length == 0 || imgList[0].status == 2)
          this.fotoAlterado = imgList;
      } else {
        this.obj.foto = null;
        imgList = null;
        this.$swal({
          title: "Cliente ainda não cadastrado!",
          icon: "error",
          showConfirmButton: false,
          toast: true,
          timer: 1000,
          position: "top-end",
        });
      }
    },
    close(idSel) {
      this.loaded = false;
      this.$emit("close", idSel);
    },
    async carregar() {
      if (this.id) {
        let res = await ClientesLib.getAllClientes({
          cod_cliente: this.id,
        });

        console.log("res clientes", res);
        if (res && res.success) {
          this.obj = res.data[0];
          if (!this.obj.foto) this.obj.foto = [];
          this.menuSelected = "Resumo";
          setTimeout(() => {
            this.loaded = true;
          }, 2000);
        }
      } else {
        this.menuSelected = "Cadastro";

        this.obj = {
          cod_cliente: null,
          Nome: "",
          Telefone: "",
          UF: "",
          Cidade: "",
          Logradouro: "",
          Numero: "",
          Bairro: "",
          Email: "",
          CGC: "",
          complemento: "",
          CEP: "",
          negativado: false,
          motivo_negativado: "",
          cod_empresa: null,
          dt_cadastro: moment().format("YYYY-MM-DD"),

          situacao: "Ativo",
          situacao_acesso: "Pendente",
          dt_nascimento: ``,
          sexo: "M",
          saldo: 0,
          cliente: 1,
          funcionario: 0,
          fornecedor: 0,
          foto: [],
        };
      }
    },
    validaCPF() {
      this.cpfValido = null;
      if (this.obj.CGC && this.obj.CGC != "") {
        if (
          !validador.string.validarCPF(this.obj.CGC) &&
          !validador.string.validarCNPJ(this.obj.CGC)
        ) {
          this.$swal(
            "CPF/CNPJ INVÁLIDO!",
            "CPF informado está incorreto!",
            "error"
          );
          this.cpfValido = false;
        } else {
          this.cpfValido = true;
        }
      }
    },
    async buscarCEP() {
      this.loadingCEP = true;
      try {
        const result = await cep.buscarCEP(this.obj.CEP);
        if (result && result.street) {
          this.obj.Bairro = result.neighborhood;
          this.obj.Logradouro = result.street;

          this.$forceUpdate();
        }
      } catch (err) {
        console.log("ERROR ON BUSCAR CEP");
      }
      this.loadingCEP = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.textCadastro {
  font-size: 0.7em;
  font-weight: bold;
}
.menu-lateral {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 4px;
  color: #333;
  width: 100%;

  div {
    font-size: 1.2em;
    padding: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 3px;
    &:hover,
    &.selected {
      color: #88d63b;
      background-color: #f9f9f9;
    }
  }
}

/* Mobile styles */
.mobile-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f8f9fa;
}

.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.mobile-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  text-align: center;
  flex-grow: 1;
}

.back-button {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  border-radius: 50%;

  &:active {
    background-color: rgba(0, 0, 0, 0.05);
  }
}

.mobile-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #e9ecef;
}

.mobile-form {
  flex-grow: 1;
  padding: 20px;
  overflow-y: auto;
}

.mobile-input-group {
  margin-bottom: 20px;

  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #495057;
  }

  input {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #ddd;
    background-color: #fff;
    font-size: 16px;

    &:focus {
      border-color: #88d63b;
      box-shadow: 0 0 0 2px rgba(136, 214, 59, 0.25);
    }
  }
}

.mobile-actions {
  margin-top: 30px;

  .btn {
    padding: 12px;
    font-size: 16px;
    border-radius: 8px;
  }
}

.mobile-tabs {
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 12px;
    font-size: 12px;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.2s ease;

    i {
      font-size: 20px;
      margin-bottom: 4px;
    }

    &.active {
      color: #88d63b;
    }

    &:active {
      transform: scale(0.95);
    }
  }
}

.invalid-feedback {
  color: #dc3545;
  font-size: 0.875em;
  margin-top: 5px;
}
</style>
